// removed by extract-text-webpack-plugin
module.exports = {"project_list":"project_list","header":"header","rightBlock":"rightBlock","projects_wrapper":"projects_wrapper","project_item":"project_item","title_container":"title_container","data_wrapper":"data_wrapper","flex":"flex","addresses_count":"addresses_count","bro_fi":"bro_fi","option":"option"};


//////////////////
// WEBPACK FOOTER
// ./src/view/screens/ProjectsList/style.scss
// module id = 490
// module chunks = 0